import styled from "styled-components";

interface StyledThumbProps {
  size: number;
}

export default styled.span<StyledThumbProps>`
  transform: rotate(-45deg);
  font-size: ${({ size }) => Math.round(size * 0.4615)}px;
  font-weight: 500;
  color: #ffffff;
`;
